export default __webpack_public_path__ + "static/media/loading.b68b9f40.gif";